import { render } from "./Dash.vue?vue&type=template&id=ea6d7b28"
import script from "./Dash.vue?vue&type=script&lang=js"
export * from "./Dash.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__